<template>
  <div class="row">
    <template v-if="!revealed">
      <div class="col mb-3">
        <label :for="`voter_${electionCodeInputProps.attribute}`" v-text="electionCodeInputProps.label"/>
        <button type="button"
                :id="`voter_${electionCodeInputProps.attribute}`"
                @click.prevent="reveal"
                class="btn btn-outline-secondary text-dark form-control">
          <i class="fas fa-eye"></i>
          {{ $t('js.backend.voter_secrets.reveal') }}
        </button>
      </div>
    </template>
    <template v-else>
      <BootstrapInput
          @input-changed="handleChange"
          :disabled="activeAttribute && activeAttribute !== electionCodeInputProps.attribute"
          scope="voter"
          :input="electionCodeInputProps"
      />
    </template>
    <BootstrapInput
        @input-changed="handleChange"
        :disabled="activeAttribute && activeAttribute !== publicKeyInputProps.attribute"
        scope="voter"
        :input="publicKeyInputProps"
    />
  </div>
</template>

<script>
import apiClient from "../../entrypoints/frontend/apiClient.js"
import BootstrapInput from "./BootstrapInput.vue";
import {InputProps} from "./BootstrapInput.vue";

export default {
  name: "VoterFormSecrets",
  components: { BootstrapInput },
  props: {
    hidden: {
      type: Boolean,
      default: true
    },
    reveal_url: {
      type: String,
      required: true
    },
    election_code_input: {
      type: Object,
      required: true
    },
    public_key_input: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      activeAttribute: null,
      electionCodeValue: '',
      revealed: !this.hidden,
    }
  },
  computed: {
    electionCodeInputProps() {
      return new InputProps({
        ...this.election_code_input,
        value: this.electionCodeValue
      })
    },
    publicKeyInputProps() {
      return new InputProps({
        ...this.public_key_input
      })
    },
  },
  methods: {
    reveal() {
      let url = this.reveal_url
      apiClient.get(url, {params: {secret: this.electionCodeInputProps.attribute}}).then(res => {
        if (res.status >= 200 && res.status < 300) {
          this.electionCodeValue = res.data[this.electionCodeInputProps.attribute]
          this.revealed = true
        }
      })
    },
    handleChange(input, change) {
      let attributeIsActive = change !== '' && change !== null && input.value !== change
      this.activeAttribute = attributeIsActive ? input.attribute : null
    }
  }
}
</script>